import React from 'react'

export const BkFlowTextArea = ({ input, name, label, size, required, meta: { touched, error } }) => (
  <div className={ 'u-form-col u-form-col--' + size }>
    <label id={ input.name + 'Label' } className="u-form-label" htmlFor={ input.name }>
      { required && '*' }
      { label }
    </label>

    <textarea { ...input } tabIndex="0" aria-labelledby={ input.name + 'Label' }></textarea>

    { touched && ((error && <p className="u-font-error">{ error }</p>))}
  </div>
)



// WEBPACK FOOTER //
// ./src/components/forms/elements/BkFlowTextArea.js